// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"faef51be","90":"e2215229","210":"88831761","216":"418e8873","318":"8c6f31cb","442":"1d20946d","492":"a950a930","530":"ff88520c","711":"ed233517","874":"b1f6bdd1"}[chunkId] + ".chunk.css";
};